import { fetchServer } from "@/features/utils/fetch";
import type { getInfoResponseType, partnerElementDataType } from "../types";

export class PartnerApiClien {
  static async getLoginStaticInformationPartner(
    page: string
  ): Promise<getInfoResponseType<partnerElementDataType>> {
    const response = await fetchServer(`olkypass/partner/public/page?page=${page}`, {
      method: "GET",
      reloadOn401: false,
      mainRoot: true
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error("fail fetch page login/rgister");
  }

  static async getDahsboardStaticInformationPartner({
    pageName
  }: {
    pageName: string;
  }): Promise<getInfoResponseType<partnerElementDataType>> {
    const response = await fetchServer(`/olkypass/partner/private/page?page=${pageName}`, {
      method: "GET",
      reloadOn401: false,
      mainRoot: true
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error("fail fetch page dashboard");
  }

  static async getPartnerUuid(): Promise<getInfoResponseType<{ partner_uuid: string }>> {
    const response = await fetchServer(`/olkypass/partner/settings`, {
      method: "GET",
      reloadOn401: false,
      mainRoot: true
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error("fail fetch getPartnerUUid");
  }
}
